import { Database, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  LOCAL_SUPABASE_STUDIO_URL,
  LOCAL_INBUCKET_URL,
} from "@/config/local-supabase-ports";
import { isLocalDev } from "@/lib/is-local-dev";

export function DevToolbar() {
  if (!isLocalDev) return null;

  return (
    <div className="flex items-center gap-2">
      <Button
        variant="outline"
        size="sm"
        className="border-green-500/50 text-green-500 hover:bg-green-500/10"
        onClick={() => window.open(LOCAL_SUPABASE_STUDIO_URL, "_blank")}
      >
        <Database className="mr-1.5 h-4 w-4" />
        Supabase
      </Button>
      <Button
        variant="outline"
        size="sm"
        className="border-blue-500/50 text-blue-500 hover:bg-blue-500/10"
        onClick={() => window.open(LOCAL_INBUCKET_URL, "_blank")}
      >
        <Mail className="mr-1.5 h-4 w-4" />
        Inbox
      </Button>
    </div>
  );
}
